import { createContext, useContext } from 'react';

import type { TreeMapChartToolbarConfig } from '../types/treemap-chart.config.js';

export const ToolbarContext = createContext<
  TreeMapChartToolbarConfig | undefined
>(undefined);

export const useToolbarConfig = () => useContext(ToolbarContext);

ToolbarContext['displayName'] = 'ToolbarContext';
